import { render, staticRenderFns } from "./W3Channels.vue?vue&type=template&id=ee12db00&scoped=true"
import script from "./W3Channels.vue?vue&type=script&lang=js"
export * from "./W3Channels.vue?vue&type=script&lang=js"
import style0 from "./W3Channels.vue?vue&type=style&index=0&id=ee12db00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee12db00",
  null
  
)

export default component.exports